var map = {
	"./Classic/10C.svg": 80406,
	"./Classic/10D.svg": 71993,
	"./Classic/10H.svg": 48445,
	"./Classic/10S.svg": 44198,
	"./Classic/11C.svg": 99209,
	"./Classic/11D.svg": 96614,
	"./Classic/11H.svg": 578,
	"./Classic/11S.svg": 24409,
	"./Classic/2C.svg": 24225,
	"./Classic/2D.svg": 10846,
	"./Classic/2H.svg": 61994,
	"./Classic/2S.svg": 66257,
	"./Classic/3C.svg": 65838,
	"./Classic/3D.svg": 77393,
	"./Classic/3H.svg": 57989,
	"./Classic/3S.svg": 60510,
	"./Classic/4C.svg": 33683,
	"./Classic/4D.svg": 27468,
	"./Classic/4H.svg": 79928,
	"./Classic/4S.svg": 85827,
	"./Classic/5C.svg": 44016,
	"./Classic/5D.svg": 37807,
	"./Classic/5H.svg": 37723,
	"./Classic/5S.svg": 36608,
	"./Classic/6C.svg": 10093,
	"./Classic/6D.svg": 51778,
	"./Classic/6H.svg": 31462,
	"./Classic/6S.svg": 35709,
	"./Classic/7C.svg": 62442,
	"./Classic/7D.svg": 72853,
	"./Classic/7H.svg": 54401,
	"./Classic/7S.svg": 66554,
	"./Classic/8C.svg": 38943,
	"./Classic/8D.svg": 73056,
	"./Classic/8H.svg": 82116,
	"./Classic/8S.svg": 97327,
	"./Classic/9C.svg": 65884,
	"./Classic/9D.svg": 36067,
	"./Classic/9H.svg": 51143,
	"./Classic/9S.svg": 7500,
	"./Classic/AC.svg": 76548,
	"./Classic/AD.svg": 81227,
	"./Classic/AH.svg": 33375,
	"./Classic/AS.svg": 49780,
	"./Classic/Card.svg": 41734,
	"./Classic/Empty.svg": 1135,
	"./Classic/JC.svg": 52409,
	"./Classic/JD.svg": 95574,
	"./Classic/JH.svg": 64306,
	"./Classic/JS.svg": 70729,
	"./Classic/KC.svg": 49318,
	"./Classic/KD.svg": 51913,
	"./Classic/KH.svg": 27949,
	"./Classic/KS.svg": 1878,
	"./Classic/QC.svg": 51316,
	"./Classic/QD.svg": 84379,
	"./Classic/QH.svg": 12143,
	"./Classic/QS.svg": 27556,
	"./Classic/SUITC.svg": 11062,
	"./Classic/SUITD.svg": 67897,
	"./Classic/SUITH.svg": 97373,
	"./Classic/SUITS.svg": 16806,
	"./DannyDarko/10C.svg": 66349,
	"./DannyDarko/10D.svg": 37826,
	"./DannyDarko/10H.svg": 43750,
	"./DannyDarko/10S.svg": 24317,
	"./DannyDarko/2C.svg": 77364,
	"./DannyDarko/2D.svg": 3483,
	"./DannyDarko/2H.svg": 19343,
	"./DannyDarko/2S.svg": 4132,
	"./DannyDarko/3C.svg": 99671,
	"./DannyDarko/3D.svg": 10488,
	"./DannyDarko/3H.svg": 34348,
	"./DannyDarko/3S.svg": 94343,
	"./DannyDarko/4C.svg": 3722,
	"./DannyDarko/4D.svg": 75349,
	"./DannyDarko/4H.svg": 19809,
	"./DannyDarko/4S.svg": 45754,
	"./DannyDarko/5C.svg": 23917,
	"./DannyDarko/5D.svg": 14626,
	"./DannyDarko/5H.svg": 96870,
	"./DannyDarko/5S.svg": 24413,
	"./DannyDarko/6C.svg": 59344,
	"./DannyDarko/6D.svg": 25231,
	"./DannyDarko/6H.svg": 97467,
	"./DannyDarko/6S.svg": 24640,
	"./DannyDarko/7C.svg": 31603,
	"./DannyDarko/7D.svg": 63916,
	"./DannyDarko/7H.svg": 16376,
	"./DannyDarko/7S.svg": 73251,
	"./DannyDarko/8C.svg": 29462,
	"./DannyDarko/8D.svg": 4697,
	"./DannyDarko/8H.svg": 81149,
	"./DannyDarko/8S.svg": 76902,
	"./DannyDarko/9C.svg": 31913,
	"./DannyDarko/9D.svg": 29318,
	"./DannyDarko/9H.svg": 49634,
	"./DannyDarko/9S.svg": 73465,
	"./DannyDarko/AC.svg": 81233,
	"./DannyDarko/AD.svg": 82734,
	"./DannyDarko/AH.svg": 44410,
	"./DannyDarko/AS.svg": 39201,
	"./DannyDarko/Card.svg": 77035,
	"./DannyDarko/Empty.svg": 86052,
	"./DannyDarko/JC.svg": 22476,
	"./DannyDarko/JD.svg": 56371,
	"./DannyDarko/JH.svg": 87799,
	"./DannyDarko/JS.svg": 80860,
	"./DannyDarko/KC.svg": 10607,
	"./DannyDarko/KD.svg": 9488,
	"./DannyDarko/KH.svg": 18548,
	"./DannyDarko/KS.svg": 3199,
	"./DannyDarko/QC.svg": 36289,
	"./DannyDarko/QD.svg": 27358,
	"./DannyDarko/QH.svg": 44330,
	"./DannyDarko/QS.svg": 35793,
	"./DannyDarko/SUITC.svg": 84525,
	"./DannyDarko/SUITD.svg": 26210,
	"./DannyDarko/SUITH.svg": 5894,
	"./DannyDarko/SUITS.svg": 10141,
	"./DannyLight/10C.svg": 12238,
	"./DannyLight/10D.svg": 10737,
	"./DannyLight/10H.svg": 35013,
	"./DannyLight/10S.svg": 55326,
	"./DannyLight/2C.svg": 81769,
	"./DannyLight/2D.svg": 79174,
	"./DannyLight/2H.svg": 99490,
	"./DannyLight/2S.svg": 6969,
	"./DannyLight/3C.svg": 79318,
	"./DannyLight/3D.svg": 54553,
	"./DannyLight/3H.svg": 31005,
	"./DannyLight/3S.svg": 26758,
	"./DannyLight/4C.svg": 37659,
	"./DannyLight/4D.svg": 4596,
	"./DannyLight/4H.svg": 99536,
	"./DannyLight/4S.svg": 42987,
	"./DannyLight/5C.svg": 4792,
	"./DannyLight/5D.svg": 83511,
	"./DannyLight/5H.svg": 69043,
	"./DannyLight/5S.svg": 56936,
	"./DannyLight/6C.svg": 99189,
	"./DannyLight/6D.svg": 43914,
	"./DannyLight/6H.svg": 94,
	"./DannyLight/6S.svg": 4517,
	"./DannyLight/7C.svg": 72114,
	"./DannyLight/7D.svg": 22397,
	"./DannyLight/7H.svg": 10745,
	"./DannyLight/7S.svg": 3266,
	"./DannyLight/8C.svg": 33175,
	"./DannyLight/8D.svg": 60344,
	"./DannyLight/8H.svg": 84204,
	"./DannyLight/8S.svg": 27847,
	"./DannyLight/9C.svg": 27220,
	"./DannyLight/9D.svg": 36987,
	"./DannyLight/9H.svg": 52847,
	"./DannyLight/9S.svg": 53988,
	"./DannyLight/AC.svg": 72332,
	"./DannyLight/AD.svg": 6227,
	"./DannyLight/AH.svg": 37655,
	"./DannyLight/AS.svg": 30716,
	"./DannyLight/Card.svg": 62510,
	"./DannyLight/Empty.svg": 33607,
	"./DannyLight/JC.svg": 31089,
	"./DannyLight/JD.svg": 32590,
	"./DannyLight/JH.svg": 94266,
	"./DannyLight/JS.svg": 89057,
	"./DannyLight/KC.svg": 23262,
	"./DannyLight/KD.svg": 36641,
	"./DannyLight/KH.svg": 97621,
	"./DannyLight/KS.svg": 80174,
	"./DannyLight/QC.svg": 51100,
	"./DannyLight/QD.svg": 9379,
	"./DannyLight/QH.svg": 40807,
	"./DannyLight/QS.svg": 44,
	"./DannyLight/SUITC.svg": 10078,
	"./DannyLight/SUITD.svg": 19009,
	"./DannyLight/SUITH.svg": 53813,
	"./DannyLight/SUITS.svg": 9518,
	"./PlayingCards/10C.svg": 79859,
	"./PlayingCards/10D.svg": 95820,
	"./PlayingCards/10H.svg": 64632,
	"./PlayingCards/10S.svg": 5155,
	"./PlayingCards/2C.svg": 48218,
	"./PlayingCards/2D.svg": 55397,
	"./PlayingCards/2H.svg": 74801,
	"./PlayingCards/2S.svg": 25418,
	"./PlayingCards/3C.svg": 46077,
	"./PlayingCards/3D.svg": 12146,
	"./PlayingCards/3H.svg": 94390,
	"./PlayingCards/3S.svg": 13517,
	"./PlayingCards/4C.svg": 63620,
	"./PlayingCards/4D.svg": 25771,
	"./PlayingCards/4H.svg": 89823,
	"./PlayingCards/4S.svg": 87380,
	"./PlayingCards/5C.svg": 12327,
	"./PlayingCards/5D.svg": 9928,
	"./PlayingCards/5H.svg": 39580,
	"./PlayingCards/5S.svg": 60183,
	"./PlayingCards/6C.svg": 82878,
	"./PlayingCards/6D.svg": 26433,
	"./PlayingCards/6H.svg": 81973,
	"./PlayingCards/6S.svg": 83758,
	"./PlayingCards/7C.svg": 18001,
	"./PlayingCards/7D.svg": 36174,
	"./PlayingCards/7H.svg": 21146,
	"./PlayingCards/7S.svg": 95201,
	"./PlayingCards/8C.svg": 75720,
	"./PlayingCards/8D.svg": 48551,
	"./PlayingCards/8H.svg": 33475,
	"./PlayingCards/8S.svg": 81048,
	"./PlayingCards/9C.svg": 67851,
	"./PlayingCards/9D.svg": 79524,
	"./PlayingCards/9H.svg": 70464,
	"./PlayingCards/9S.svg": 62523,
	"./PlayingCards/AC.svg": 19123,
	"./PlayingCards/AD.svg": 62380,
	"./PlayingCards/AH.svg": 38520,
	"./PlayingCards/AS.svg": 97443,
	"./PlayingCards/Card.svg": 64737,
	"./PlayingCards/Empty.svg": 60614,
	"./PlayingCards/JC.svg": 18226,
	"./PlayingCards/JD.svg": 52157,
	"./PlayingCards/JH.svg": 6329,
	"./PlayingCards/JS.svg": 65666,
	"./PlayingCards/KC.svg": 14229,
	"./PlayingCards/KD.svg": 91018,
	"./PlayingCards/KH.svg": 39870,
	"./PlayingCards/KS.svg": 19557,
	"./PlayingCards/QC.svg": 17507,
	"./PlayingCards/QD.svg": 47324,
	"./PlayingCards/QH.svg": 59752,
	"./PlayingCards/QS.svg": 22835,
	"./PlayingCards/SUITC.svg": 19191,
	"./PlayingCards/SUITD.svg": 24120,
	"./PlayingCards/SUITH.svg": 47980,
	"./PlayingCards/SUITS.svg": 13863,
	"./PlayingCards/black_joker.svg": 32772,
	"./PlayingCards/red_joker.svg": 7748
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 96261;